import BaseFormController from "../../validation/BaseFormController";
import {FormField, RequiredFormField} from "../../validation/FormField";
import {none, option} from "ts-option";
import FormValidation from "../../validation/FormValidation";
import {ValidationResult} from "../../validation/ValidationResult";
import PartnerBrandRewardsData, {RewardsStatus} from "../../model/partnerBrand/PartnerBrandRewardsData";
import * as _ from "underscore";
import moment = require("moment");

const uuidv4 = require("uuid/v4");

/**
 * Partner brand rewards data form.
 */
export default class PartnerBrandRewardsDataForm extends BaseFormController<PartnerBrandRewardsDataForm> {
	constructor(formId: string,
		public readonly status: RequiredFormField<string>,
		public readonly signUpDate: RequiredFormField<moment.Moment>) {
		super(status, formId);
	}

	static createPartnerBrandRewardsDataForm({
		status = none,
		signUpDate = none
	}) {
		return new PartnerBrandRewardsDataForm(
			uuidv4(),
			RequiredFormField.create<string>(status, "Rewards status is required"),
			RequiredFormField.create<moment.Moment>(signUpDate, "Sign up date is required"),
		)
	}

	public static createEmpty(): PartnerBrandRewardsDataForm {
		const defaultStatus = _.invert(RewardsStatus)[RewardsStatus.SILVER];
		return this.createPartnerBrandRewardsDataForm({status: option(defaultStatus), signUpDate: option(moment())});
	}

	static createFromPartnerBrandRewardsData(partnerBrandRewardsData: PartnerBrandRewardsData) {
		return PartnerBrandRewardsDataForm.createPartnerBrandRewardsDataForm({
			signUpDate: option(partnerBrandRewardsData.signUpDate),
			status: option(partnerBrandRewardsData.status)
		});
	}

	validate(): PartnerBrandRewardsDataForm {
		return FormValidation.validateForm<PartnerBrandRewardsDataForm>(this, (form, config) => form.copy(config));
	}

	onValid(onValid: (partnerBrandRewardsData: PartnerBrandRewardsData) => void): ValidationResult<PartnerBrandRewardsData> {
		return FormValidation.validateFields([this.status, this.signUpDate],
			() => {
				return new PartnerBrandRewardsData(this.signUpDate.getValue(), this.status.getValue(), 0, 0, 0, 0)
			}).onSuccess(partnerBrand => onValid(partnerBrand));
	}

	copy({
		status = this.status,
		signUpDate = this.signUpDate
	}): PartnerBrandRewardsDataForm {
		return new PartnerBrandRewardsDataForm(this.formId, status, signUpDate);
	}

	fields(): Array<FormField<any>> {
		return [this.status, this.signUpDate];
	}
}
